import { createIcon } from '@/utils/factoryUtil'

export const SVGBrandTCGPlayer = createIcon('SVGBrandTCGPlayer', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M19.32,19.79l-14.15,2.1c-3.32.48-5.58,3.55-5.1,6.83l7.07,47.17c.5,3.28,3.57,5.55,6.88,5.07l5.3-.78V19.79Z' />
    <path d='M94.83,21.89l-13.97-2.07v60.38l5.12.77c3.3.48,6.38-1.78,6.88-5.07l7.07-47.17c.5-3.28-1.78-6.35-5.1-6.83v-.02Z' />
    <path d='M31.21,34.46' />
    <path d='M71.03,13.12H29.17c-3.33,0-6.05,2.68-6.05,6.02v61.72c0,3.32,2.7,6.02,6.05,6.02h41.87c3.33,0,6.05-2.68,6.05-6.02V19.14c0-3.32-2.7-6.02-6.05-6.02ZM68.57,45.46l-18.1,26.28c-.85,1.22-2.77.63-2.77-.85v-13.63h-14.83c-1.12,0-1.85-1.17-1.37-2.17l12.5-25.67c.25-.52.78-.85,1.37-.85h13.88c1.12,0,1.85,1.17,1.37,2.17l-6.02,12.35h12.72c1.22,0,1.93,1.37,1.25,2.37Z' />
  </svg>
))
